import { render, staticRenderFns } from "./vesselTypeChart.vue?vue&type=template&id=30abf122"
import script from "./vesselTypeChart.vue?vue&type=script&lang=js"
export * from "./vesselTypeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports